// extracted by mini-css-extract-plugin
export default {"product-category-card":"ProductCategoryCard_product-category-card__r2+jO","title":"ProductCategoryCard_title__oTb7a"};